import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.61,6.46,8.54,10.68h0a.67.67,0,0,1-.24.16A.68.68,0,0,1,8,10.9a.72.72,0,0,1-.29-.06.78.78,0,0,1-.24-.16h0L3.4,6.46a.75.75,0,1,1,1.08-1L7.25,8.29V2a.75.75,0,0,1,1.5,0V8.29l2.78-2.87a.75.75,0,1,1,1.08,1ZM14.75,14a.76.76,0,0,0-.75-.75H2a.75.75,0,0,0,0,1.5H14A.76.76,0,0,0,14.75,14Z';
const draw24px =
  'M12,3.25a.75.75,0,0,1,.75.75v9.51L15,11.24a.74.74,0,0,1,1.06,0,.75.75,0,0,1,.22.53.79.79,0,0,1-.22.53l-3.56,3.55a.78.78,0,0,1-.24.16.73.73,0,0,1-.58,0,.78.78,0,0,1-.24-.16L7.92,12.3a.75.75,0,0,1,0-1.06.74.74,0,0,1,1.06,0l2.27,2.27V4A.76.76,0,0,1,12,3.25Zm8,16H4a.75.75,0,0,0,0,1.5H20a.75.75,0,0,0,0-1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowAlignDownIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowAlignDown')) as IconWithRender;

ArrowAlignDownIcon.displayName = 'ArrowAlignDownIcon';
ArrowAlignDownIcon.propTypes = Icon.propTypes;
ArrowAlignDownIcon.renderIcon = (props) => <ArrowAlignDownIcon {...props} />;
export default ArrowAlignDownIcon;
